/**
 * Cihaz `isActive` bayrağının kullanıcıya görünen dili (Workspace-#148).
 *
 * `isActive` = cihaz KOTA ALMAYA açık mı? Panelde her yerde bu dil kullanılır:
 *   durum  → "Kota Almaya Açık" / "Kota Almaya Kapalı"
 *   eylem  → "Kota Almaya Aç"   / "Kota Almaya Kapa"
 *   alan   → "Kota Alma"
 *
 * VERİ DEĞİŞMEZ: operasyon anahtarları ("Aktiflik" / "AktiflikAc" /
 * "AktiflikKapat"), izin anahtarı (`devices.toggleActivity`) ve server'ın
 * yazdığı ham log değerleri (infoName "Aktiflik", "Aktif"/"Pasif") olduğu gibi
 * kalır. Aşağıdaki `displayLog*` eşleyicileri yalnız GÖSTERİM içindir; filtre /
 * karşılaştırma ham değerle yapılmaya devam eder.
 */

export const DEVICE_ACTIVITY_FIELD_LABEL = "Kota Alma";

export const DEVICE_ACTIVITY_STATE_OPEN = "Kota Almaya Açık";
export const DEVICE_ACTIVITY_STATE_CLOSED = "Kota Almaya Kapalı";

export const DEVICE_ACTIVITY_ACTION_OPEN = "Kota Almaya Aç";
export const DEVICE_ACTIVITY_ACTION_CLOSE = "Kota Almaya Kapa";

/** Not boş bırakılınca server'a giden varsayılan açıklamalar. */
export const DEVICE_ACTIVITY_DEFAULT_NOTE_OPEN = "Cihaz kota almaya açıldı.";
export const DEVICE_ACTIVITY_DEFAULT_NOTE_CLOSE = "Cihaz kota almaya kapatıldı.";

/** Server'ın log'a yazdığı ham alan adı ve değerleri (değişmez). */
export const LEGACY_ACTIVITY_INFO_NAME = "Aktiflik";
const LEGACY_ACTIVITY_VALUES = {
  Aktif: DEVICE_ACTIVITY_STATE_OPEN,
  Pasif: DEVICE_ACTIVITY_STATE_CLOSED,
};

/** isActive → "Kota Almaya Açık" / "Kota Almaya Kapalı" */
export const deviceActivityStateLabel = (isActive) =>
  isActive ? DEVICE_ACTIVITY_STATE_OPEN : DEVICE_ACTIVITY_STATE_CLOSED;

/** Mevcut isActive'e göre yapılabilecek eylem: açıksa "Kapa", kapalıysa "Aç". */
export const deviceActivityToggleLabel = (isActive) =>
  isActive ? DEVICE_ACTIVITY_ACTION_CLOSE : DEVICE_ACTIVITY_ACTION_OPEN;

/** Log alan adı: "Aktiflik" → "Kota Alma"; diğerleri aynen. */
export const displayLogInfoName = (infoName) =>
  infoName === LEGACY_ACTIVITY_INFO_NAME ? DEVICE_ACTIVITY_FIELD_LABEL : infoName;

/**
 * Log değeri: yalnız "Aktiflik" alanında "Aktif"/"Pasif" eşlenir — başka
 * alanların (bileşen, firma vb.) "Aktif"/"Pasif" değerine dokunulmaz.
 */
export const displayLogValue = (infoName, value) => {
  if (infoName !== LEGACY_ACTIVITY_INFO_NAME) return value;
  return LEGACY_ACTIVITY_VALUES[value] ?? value;
};

/**
 * Eski log açıklama/not ifadelerini yeni dile çevirir. Zaten yeni dilde olan
 * metin ve ilgisiz metin aynen döner (idempotent).
 *   "Cihaz kapatıldı."            → "Cihaz kota almaya kapatıldı."
 *   "Cihaz açıldı."               → "Cihaz kota almaya açıldı."
 *   "aktife alınması"             → "kota almaya açılması"
 *   "pasife alınması"             → "kota almaya kapatılması"
 *   "... açık olarak taşındı."    → "... kota almaya açık olarak taşındı."
 *   "... kapalı olarak taşındı."  → "... kota almaya kapalı olarak taşındı."
 */
export const displayLogText = (text) => {
  if (typeof text !== "string" || !text) return text;
  return text
    .replace(/Cihaz (kapatıldı|açıldı)(?=\.|$)/g, (_m, verb) => `Cihaz kota almaya ${verb}`)
    .replace(/\baktife alınması/g, "kota almaya açılması")
    .replace(/\bpasife alınması/g, "kota almaya kapatılması")
    .replace(
      /(kota almaya )?(açık|kapalı) olarak taşındı/g,
      (match, already, state) => (already ? match : `kota almaya ${state} olarak taşındı`)
    );
};

/**
 * Bir log kaydının (veya `info[]` öğesinin) gösterim kopyası: infoName,
 * valueFrom/valueTo, description ve note eşlenir; diğer alanlar aynen kalır.
 * Ham kayıt değiştirilmez.
 */
export const displayLogEntry = (entry) => {
  if (!entry || typeof entry !== "object") return entry;
  const out = { ...entry };
  if ("valueFrom" in entry) out.valueFrom = displayLogValue(entry.infoName, entry.valueFrom);
  if ("valueTo" in entry) out.valueTo = displayLogValue(entry.infoName, entry.valueTo);
  if ("infoName" in entry) out.infoName = displayLogInfoName(entry.infoName);
  if ("description" in entry) out.description = displayLogText(entry.description);
  if ("note" in entry) out.note = displayLogText(entry.note);
  return out;
};
